module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABKElEQVQoU5WSP0sDQRDFf3MRcnp+AS1FbARB5SKIiH4EbewUiTkbSSsK6ncIWORMFNOlsrEXUgjm8A/W1lopaYI5IRnZ4y4kIU222OXNvDf7ZnaFeC1U1Em3yANbSSw+70KbwvuuNA0Wsy2VdDbVoYpyG45TTpJRkV+yCHtti52XA/mQuHLNErynnDwPVI/gypUudxQ/tFkX19cTlGZwKAWTUGWq7sl9QkywW9Q8gmME9dBm09hwi3qNsBZ4MmcEvTh28hAJAk8yhrBxo3YD7Ld9aQzDhtsnGOa/N9YVJJYyvh7zR6l+JN+GOH+pk84Y5xNfnP7MkE63iCx1m3Z9zQEXClVRLIRtoBJ4ctZtenCsi2WdTnVYNTe0LR5fs/LZN9aRH27Ur/EPCQKuryyO7P0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/happy.png
// module id = jo02
// module chunks = 1